import { useState, useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WhatsAppButton = () => {
  const [phoneNumber, setPhoneNumber] = useState("50937209459");
  const [message, setMessage] = useState("Hello! I need help with my shipment.");

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API}/settings/site`);
        if (res.data.whatsapp_number) {
          setPhoneNumber(res.data.whatsapp_number);
        }
        if (res.data.whatsapp_message) {
          setMessage(res.data.whatsapp_message);
        }
      } catch (err) {
        console.log("Using default WhatsApp settings");
      }
    };
    fetchSettings();
  }, []);

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#128C7E] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all group"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      data-testid="whatsapp-btn"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" strokeWidth={0} />
      <span className="absolute right-full mr-3 bg-slate-900 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
        Chat with us
      </span>
    </motion.a>
  );
};

export default WhatsAppButton;
